import { useQuery } from "react-query";

import { useApiClient } from "api/useApiClient";

import type { GetActivePatientsArgs } from "../schemas";

const getActivePatientsQueryKey = (args: GetActivePatientsArgs) =>
  ["getActivePatients", args.health_care_organization_id, args.params] as const;

export const useGetActivePatients = (args: GetActivePatientsArgs) => {
  const client = useApiClient();

  return useQuery(getActivePatientsQueryKey(args), () => client.getActivePatients(args));
};
